import type { ItemDetail } from "../../data/catalog.ts";
import type { AttrRowSpec } from "./AttrRow.tsx";

type OpticsAttrs = NonNullable<ItemDetail["opticsAttributes"]>;

export function OpticsSpecLine({ a }: { a: OpticsAttrs }) {
  // Glance summary: magnification · reticle (when present).
  const parts: string[] = [a.magnification];
  if (a.reticle) parts.push(a.reticle);
  return <p className="text-[15px] font-medium text-slate-600 tabular-nums">{parts.join(" · ")}</p>;
}

export function buildOpticsRows(a: OpticsAttrs): AttrRowSpec[] {
  return [
    { label: "Manufacturer", value: a.manufacturer, required: true },
    { label: "Model", value: a.model, required: true },
    { label: "Magnification", value: a.magnification, mono: true, required: true },
    { label: "Reticle", value: a.reticle },
    { label: "Mount", value: a.mount },
    { label: "Illuminated", value: a.isIlluminated ? "Yes" : "No" },
    { label: "Battery", value: a.batteryType },
  ];
}
